import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import SectionHeading from '../../../components/SectionHeading';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const OverviewModalCurriculumSection = ({
  children
}) => {
  const {
    isMobile
  } = useMediaQuery();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(SectionHeading, {
      paddingBlockEnd: "400",
      paddingBlockStart: "800",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.overviewModal.curriculum"
      })
    }), /*#__PURE__*/_jsx(View, {
      backgroundColor: "fill-surface-default",
      children: /*#__PURE__*/_jsx(View, {
        padding: "800",
        paddingInline: isMobile ? '300' : undefined,
        children: children
      })
    })]
  });
};
export default OverviewModalCurriculumSection;